import registerPWAController from './PWAController';
import registerPWAService from './PWAService';
import registerQRCodeService from './QRCodeService';
import { Html5QrcodeFactory } from './Html5QrcodeFactory';

export default function registerPWA(angular) {
    registerPWAController(angular.module('assessmentFrontendControllers'));
    registerPWAService(angular.module('assessmentFrontendServices'));
    registerQRCodeService(angular.module('assessmentFrontendServices'));
    
    // Register the QR code scanner factory
    angular.module('assessmentFrontendServices').factory('QRCodeScannerFactory', () => new Html5QrcodeFactory());
}
